import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import { ICaseDecision } from "../model/CaseDecision";
import { IInvalidatedCaseDecision } from "../model/InvalidatedCaseDecision";
import { ICaseDecisionService } from "../service/CaseDecisionService";

export default class UpdateCaseDecisionInteractor {
  private resource: UpdateResourceInteractor<ICaseDecision>;
  private caseDecisionService: ICaseDecisionService;

  constructor({ updateResource, caseDecisionService }: any) {
    this.resource = updateResource;
    this.caseDecisionService = caseDecisionService;
  }

  async execute(
    item: ICaseDecision,
    indexes: number[],
    courtCase: any = undefined,
    invalidatedCaseDecision: IInvalidatedCaseDecision
  ) {
    return this.caseDecisionService.updateCaseDecision(
      item,
      indexes,
      courtCase,
      invalidatedCaseDecision
    );
  }
}
